import { DispatchPayload, GlobalActions } from 'types/global/actions';

// Map of listeners for each device
const listeners: Record<string, Map<string, (e: CustomEvent) => void>> = {};

const dispatchEvent = ({ leafId, event, data }: DispatchPayload) => {
  window.dispatchEvent(
    new CustomEvent(event, {
      detail: {
        leafId,
        data,
      },
    }),
  );
};

const subscribe = (leafId: string, event: GlobalActions, listener: (e: CustomEvent) => void) => {
  if (listeners?.[leafId]?.get(event)) {
    unsubscribe(leafId, event);
  }

  window.addEventListener(event, listener as EventListener);
  listeners[leafId] = listeners[leafId]?.set(event, listener) || new Map([[event, listener]]);
};

const unsubscribe = (leafId: string, event: GlobalActions) => {
  const listener = listeners?.[leafId]?.get(event);
  if (listener) {
    listeners[leafId].delete(event);
    window.removeEventListener(event, listener as EventListener);
  }
};

export { dispatchEvent, subscribe, unsubscribe };
